import { Link } from "react-router-dom";
import wallpaper from "../../assets/wallpaper.jpg";
import { Header } from "../../header/Header";
import individualImg from "../../assets/individual.jpg";
import childImg from "../../assets/child.jpg";
import coupleImg from "../../assets/couple.jpg";
import CounsellingCard from "./CounsellingCard";
import { AboutFounder } from "./AboutFounder";
import { Testimonials } from "./Testimonials";
import { Doubt } from "../aboutus/Doubt";
import { Footer } from "../footer/Footer";

export const Home = () => {
  return (
    <>
      <Header />

      {/* Hero */}
      <section
        className="relative flex min-h-[calc(100vh-5rem)] items-center justify-center overflow-hidden bg-cover bg-center"
        style={{ backgroundImage: `url(${wallpaper})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-brand-950/70 via-brand-900/50 to-brand-950/80" />
        <div className="relative z-10 mx-auto max-w-4xl px-4 py-24 text-center sm:px-6">
          <span className="animate-fade-up mb-6 inline-block rounded-full border border-white/30 bg-white/10 px-5 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-white backdrop-blur-sm">
            Mind Wonders Psychological Counselling
          </span>
          <h1 className="animate-fade-up font-display text-5xl font-semibold leading-tight text-white sm:text-6xl lg:text-7xl">
            We Care For Your{" "}
            <span className="bg-gradient-to-r from-sky-300 to-sea-300 bg-clip-text text-transparent">
              Happiness!!!
            </span>
          </h1>
          <p className="animate-fade-up-delay mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-blue-100">
            Cultivating change, fostering connection, empowering you — one
            conversation at a time.
          </p>
          <div className="animate-fade-up-delay-2 mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link
              to="/contact"
              className="w-full rounded-full bg-white px-8 py-4 text-sm font-bold tracking-widest text-brand-800 shadow-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl sm:w-auto"
            >
              GETTING STARTED
            </Link>
            <a
              href="https://forms.gle/your-google-form-id"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full rounded-full border-2 border-white/70 px-8 py-4 text-sm font-bold tracking-widest text-white backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:bg-white/10 sm:w-auto"
            >
              TAKE A QUICK QUIZ
            </a>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent" />
      </section>

      {/* Services cards */}
      <section className="relative bg-white py-20 sm:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mx-auto mb-14 max-w-2xl text-center">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-brand-600">
              Our Services
            </span>
            <h2 className="mt-3 font-display text-4xl font-semibold text-slate-900 sm:text-5xl">
              Counselling that meets you where you are
            </h2>
          </div>
          <div className="grid gap-8 md:grid-cols-3">
            <CounsellingCard
              imageSrc={individualImg}
              title="Individual Therapy"
              description="A one-on-one process where a trained mental health professional helps an individual explore their thoughts, feelings"
              buttonText="TAKE ME THERE"
              linkTo="/services/individual"
            />
            <CounsellingCard
              imageSrc={childImg}
              title="Child Therapy"
              description="A specialized form of therapy that provides emotional and psychological support to children and adolescents"
              buttonText="TAKE ME THERE"
              linkTo="/services/child"
            />
            <CounsellingCard
              imageSrc={coupleImg}
              title="Couple Therapy"
              description="A form of psychotherapy that helps couples improve their relationship, resolve conflicts, and strengthen their bond"
              buttonText="TAKE ME THERE"
              linkTo="/services/couple"
            />
          </div>
        </div>
      </section>

      <AboutFounder />
      <Testimonials />
      <Doubt />
      <Footer />
    </>
  );
};
